<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Smoke and Mirrors</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<p class="dedication"><em>The first book of a new series</em></p>
<p class="dedication"><em>is always for</em></p>
<p class="dedication"><em>David.</em></p>
<p class="dedication"><em>This one is no exception.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?458744ee